import { handleActions } from 'redux-actions';

import * as actions from './actions';
import * as base from "../BaseReducers";

const initialState = Object.assign({},
  base.ListState,
  base.DetailState,
  base.EditState,
);

export default handleActions(
  {
    [actions.profileShowEditForm]: (state, action) => base.showEditForm(state, action),

    [actions.profileLoadRequest]: (state, action) => base.listLoadRequest(state, action),
    [actions.profileLoadComplete]: (state, action) => base.listLoadComplete(state, action),
    [actions.profileLoadError]: (state, action) => base.listLoadError(state, action),

    [actions.profileDetailLoadRequest]: (state, action) => base.detailLoadRequest(state, action),
    [actions.profileDetailLoadComplete]: (state, action) => base.detailLoadComplete(state, action),
    [actions.profileDetailLoadError]: (state, action) => base.detailLoadError(state, action),

    [actions.profileUpdateRequest]: (state, action) => base.updateRequest(state, action),
    [actions.profileUpdateComplete]: (state, action) => base.updateComplete(state, action),
    [actions.profileUpdateError]: (state, action) => base.updateError(state, action),

    [actions.profileDeleteRequest]: (state, action) => base.deleteRequest(state, action),
    [actions.profileDeleteComplete]: (state, action) => base.deleteComplete(state, action),
    [actions.profileDeleteError]: (state, action) => base.deleteError(state, action),
  },
  initialState
);
